import { applicationTokenValidate } from 'commons/service/client/application'
import { WriteHook, useMutationManager } from 'state-manager'

export const useValidateApplicationToken: WriteHook<string, { password_reset_key: string | undefined }> = (opts) =>
  useMutationManager<string, { password_reset_key: string | undefined }>(applicationTokenValidate, opts)
